import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 99999;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  width: 100vw;
`;

export const Container = styled.div<{ isClosing: boolean }>`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 448px;
  z-index: 101;
  background-color: var(--colorBlueGray100);
  box-shadow: -11px 0px 15px -7px rgba(0, 0, 0, 0.32), -24px 0px 38px 3px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  animation: ${({ isClosing }) =>
    isClosing ? 'right-slide-out .3s forwards' : 'right-slide-in .3s forwards'};

  & > div:nth-child(2) {
    overflow-y: auto;
    overflow-y: overlay;
    overflow-x: hidden;
    flex: 1;
  }
`;

export const Background = styled.div<{ isClosing: boolean }>`
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  background-color: rgb(17 14 22 / 50%);
  width: 100vw;
  animation: ${({ isClosing }) => (isClosing ? 'fade-out .3s forwards' : 'fade-in .3s forwards')};
`;
